import { gql } from '@apollo/client'

export const FontStyleFragment = gql`
    fragment fontStyleFragment on FontSettings {
        fontFamily
        fontSize
        fontStyles
        fontColor
    }
`

export const IndentationStyleFragment = gql`
    fragment indentationStyleFragment on IndentationStyle {
        left
        right
    }
`

export const SectionTitleStylesFragment = gql`
    fragment sectionTitleStylesFragment on SectionTitleStyle {
        font {
            ...fontStyleFragment
        }
        justification
        spaceAfter
        spaceBefore
        setTextToUpper
        indentations {
            ...indentationStyleFragment
        }
        numberOfLines
        spaceBetweenLines
    }
    ${FontStyleFragment},
    ${IndentationStyleFragment}
`
